// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flight-1-H3h";
export { _1 as "__esModule", _2 as "flight" }
export default { "__esModule": _1, "flight": _2 }
